import React from 'react';
import { useInView } from 'react-intersection-observer';
import './Affiliates.css';

const Affiliates = () => {
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true
  });

  return (
    <section id="affiliates" className="affiliates-section" ref={ref}>
      <div className="container">
        <div className={`affiliates-header ${inView ? 'fade-in' : ''}`}>
          <h2 className="section-title center">PARTNERS AND SPONSORS</h2>
          <div className="title-underline center"></div>
          <p className="affiliates-intro">
            We are proud to collaborate with the following affiliate companies and sponsors who share 
            our mission. Their support is instrumental in helping us uphold the Polymath strategy.
          </p>
        </div>

        <div className={`coming-soon ${inView ? 'fade-in' : ''}`}>
          <div className="coming-soon-content">
            <i className="fas fa-handshake"></i>
            <h3>Company Affiliates & Sponsorships</h3>
            <p>
              Building strategic alliances with industry leaders to deliver comprehensive solutions 
              and drive sustainable value creation across organizations.
            </p>
            <div className="coming-soon-badge">
              <i className="fas fa-clock"></i>
              Coming Soon
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Affiliates;

